import { FC, useCallback } from "react";
import { BulletListExtension } from "@remirror/extension-list";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleBulletListButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleBulletListButton: FC<ToggleBulletListButtonProps> = (
  props,
) => {
  const { toggleBulletList } = useCommands<BulletListExtension>();

  const handleSelect = useCallback(() => {
    if (toggleBulletList.enabled()) {
      toggleBulletList();
      props.onBlur();
    }
  }, [props, toggleBulletList]);

  const active = useActive<BulletListExtension>().bulletList();
  const enabled = toggleBulletList.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleBulletList"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
